module.exports = __webpack_public_path__ + "img/empty-icon-red.af5bc3d9.svg";